<ng-container [formGroup]="parentForm">
  <div [formGroupName]="groupName">
    <odq-input-group collapseField="false"
                     [responsiveGutter]="{xs: 0, sm: 6, md: 8, lg: 8, xl:8}">
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md: 75, lg: 75, xl:75}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.Line1' | translate"
                        formControlName="line1">
        </odq-text-input>
      </odq-input>
    </odq-input-group>
    <odq-input-group collapseField="false"
                     [responsiveGutter]="{xs: 0, sm: 6, md: 8, lg: 8, xl:8}">
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md: 75, lg: 75, xl:75}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.Line2' | translate"
                        formControlName="line2">
        </odq-text-input>
      </odq-input>
    </odq-input-group>
    <odq-input-group collapseField="false"
                     [responsiveGutter]="{xs: 0, sm: 6, md: 8, lg: 8, xl:8}">
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md:25, lg: 25, xl:25}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.City' | translate"
                        formControlName="city">
        </odq-text-input>
      </odq-input>
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md:25, lg: 25, xl:25}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.PostalCode' | translate"
                        formControlName="postalCode">
        </odq-text-input>
      </odq-input>
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md:25, lg: 25, xl:25}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.Prov' | translate"
                        formControlName="provinceCode">
        </odq-text-input>
      </odq-input>
      <odq-input [responsiveColPercent]="{xs: 100, sm: 100, md:25, lg: 25, xl:25}">
        <odq-text-input [placeholder]="'form.annual.declaration.section1.area1_2.address.Country' | translate"
                        formControlName="countryCode">
        </odq-text-input>
      </odq-input>
    </odq-input-group>
  </div>
</ng-container>